import { useState, useEffect } from 'react';
const breakpoints = {
    mobile: 768,
    tablet: 1025,
    desktop: 1200,
};
export const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(null);
    useEffect(() => {
        const mediaQueries = Object.keys(breakpoints).map((key) => {
            return window.matchMedia(`(max-width: ${breakpoints[key]}px)`);
        });
        const getActiveBreakpoint = () => {
            const matchingQuery = mediaQueries.find((query) => query.matches);
            const activeBreakpoint = Object.keys(breakpoints)[mediaQueries.indexOf(matchingQuery)];
            setBreakpoint(activeBreakpoint);
        };
        getActiveBreakpoint();
        mediaQueries.forEach((query) => {
            query.addEventListener('change', getActiveBreakpoint);
        });
        return () => {
            mediaQueries.forEach((query) => {
                query.removeEventListener('change', getActiveBreakpoint);
            });
        };
    }, [breakpoints]);
    return breakpoint || 'desktop';
};
